<div class="text-center p-3 px-5 position-relative">
    <div class="close">
        <img src="assets/images/closemenu.png" (click)='cancelForm()' class="position-absolute closeMenu" alt="close">
    </div>

    <h2 class="py-2 address">{{"Register.logout" | translate}}</h2>
    <p class="text-muted pb-4 ">{{"Register.logout confirm" | translate}}</p>
    <button routerLink="/login" (click)='isLogout()' class="btn btn-danger">{{"Register.logout" | translate}}</button>
</div>